import { graphql } from '@/generated/gql';

export const BUSINESS_LOG_QUERY = graphql(/* GraphQL */ `
  query BusinessLogQuery(
    $entityId: UUID!
    $entityVariant: TlscpEntityVariant!
    $offset: Int
    $limit: Int
    $includeChildren: Boolean
  ) {
    telescope {
      logEntries(
        entityId: $entityId
        entityVariant: $entityVariant
        offset: $offset
        limit: $limit
        includeChildren: $includeChildren
      ) {
        nodes {
          actorId
          actorVariant
          context
          createdAt
          entityId
          entityVariant
          id
          parentId
          parentVariant
          status
          template
        }
        totalCount
      }
    }
  }
`);
